export type OrderType = 'asc' | 'desc';
export namespace OrderType {
  export const ASC: OrderType = 'asc';
  export const DESC: OrderType = 'desc';
}
export interface OrderItem {
  value: string;
  type: OrderType;
}
